import produce from "immer";
import { CustomizationState } from "../";
import { FilterTag } from "../../../agreed/filters";
import { Cropping } from "../../../types/customization/content";
import { findEditablePicture, findPageAndDefinition } from "../../../utils/customization/finders";

export interface ChangeEditablePictureElementCroppingAndFilterAction {
  type: "changeEditablePictureElementCroppingAndFilter";
  pageKey: string;
  editablePictureKey: string;
  cropping: Cropping;
  filterTag: FilterTag;
}

export function changeEditablePictureElementCroppingAndFilter(
  state: CustomizationState,
  action: ChangeEditablePictureElementCroppingAndFilterAction
): CustomizationState {
  return produce(state, (draftState) => {
    const { page } = findPageAndDefinition(action.pageKey, draftState.template, draftState.content);
    const editablePicture = findEditablePicture(action.editablePictureKey, page);

    editablePicture.cropping = action.cropping;
    editablePicture.filterTag = action.filterTag;
  });
}
